import { Button } from '@im/ui-lib/zenith/Button';
import { Icon } from '@im/ui-lib/zenith/Icon';
import Paper from '@mui/material/Paper';
import Stack from '@mui/material/Stack';
import { styled } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import React from 'react';

type Props = {
  isCancelRequired: boolean;
  onBillingCardCancel: () => void;
  subHeaderText: string;
  summary: string;
};

export function BillingCard(props: Props) {
  const { isCancelRequired, onBillingCardCancel, subHeaderText, summary } =
    props;
  return (
    <Item>
      <Stack direction={'row'} p={4} spacing={1}>
        <Stack direction={'column'}>
          <Stack direction={'row'} spacing={1}>
            <Typography color="primary.800" variant="text-sm-medium">
              {'CNPJ'}
            </Typography>
            <Typography color="primary.700" variant="text-sm-regular">
              {subHeaderText}
            </Typography>
          </Stack>
          <Typography color="primary.700" variant="text-sm-regular">
            {summary}
          </Typography>
        </Stack>
        {isCancelRequired && (
          <Button
            onClick={onBillingCardCancel}
            size="small"
            sx={{ p: '0px !important' }}
            variant="tertiary"
          >
            <Icon iconId="XClose" />
          </Button>
        )}
      </Stack>
    </Item>
  );
}

const Item = styled(Paper)(() => ({
  background: 'var(--color-primary-50, #EFF8FF)',
  border: '2px solid var(--color-primary-600, #1570EF)',
  borderRadius: '8px',
}));
